import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { FormFieldComponent } from '../form-field/form-field.component'

@Component({
  selector: 'app-form-datepicker-input',
  templateUrl: './form-datepicker-input.component.html',
  styleUrls: ['../form-field-common.scss', './form-datepicker-input.component.scss'],
  host: { class: 'form-date-field' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormDatepickerInputComponent extends FormFieldComponent {
  @Input() minDate: Date
  @Input() maxDate: Date

  onOpen() {
    this.focused = true
  }

  onClose() {
    this.focused = false
  }
}
